import { useAccountInfoContext } from '@/hooks/useAccountInfo';
import { usePoolInfoContext } from '@/hooks/usePoolInfo';
import { useFm } from '@web3/base-hooks';
import { formatNumber } from '@web3/base-utils';
import { Tooltip } from '@bfe/moly';
import QueryIcon from '@/assets/images/bybitsol/query.svg';
import styles from './index.module.scss';

export const Overview = () => {
  const fm = useFm();
  const { accountInfo } = useAccountInfoContext();
  const { poolInfo } = usePoolInfoContext();
  const { extraYieldDTO, yieldPkg, combineLpTokens = '0' } = accountInfo || {};
  const { ratio = '0', lpCoin } = poolInfo || {};
  const exchangeAmount = Number(ratio) * Number(combineLpTokens);

  return (
    <>
      {/* 总持有 */}
      <div className={styles.totalHold}>
        <div className={styles.holdeToken}>
          <div className={styles.token}>
            <img src={lpCoin?.iconNightUrl} className={styles.icon} />
            <div className={styles.holding}>
              {fm('walletHoldings')}
              <Tooltip title={fm('walletBbsolNumAndRestaking')}>
                <QueryIcon />
              </Tooltip>
            </div>
          </div>
          <div className={styles.holdValue}>
            <div className={styles.value}>{`${formatNumber(combineLpTokens, {
              kmb: false,
              decimal: 4,
              smallNumberUseValidDigits: false,
              collapseZero: false,
            })} ${lpCoin?.symbol ?? ''}`}</div>
            <div className={styles.exchangeAmount}>
              {`≈ ${formatNumber(exchangeAmount, {
                kmb: false,
                decimal: 4,
                smallNumberUseValidDigits: false,
                collapseZero: false,
              })} ${lpCoin?.chainCode ?? ''}`}
            </div>
          </div>
        </div>
        <div className={styles.currentRatio}>
          <div className={styles.currentExchangeRate}>
            {fm('currentExchangeRate')}
          </div>
          <div className={styles.ratioValue}>{`1:${formatNumber(ratio, {
            kmb: false,
            decimal: 2,
            smallNumberUseValidDigits: false,
            collapseZero: false,
          })}`}</div>
        </div>
      </div>
      <div className={styles.gap} />
      <div className={styles.platformInfo}>
        <div className={styles.totalProfitContainer}>
          <div className={styles.totalProfit}>
            <div className={styles.totalProfitText}>{fm('totalProfitSol')}</div>
            <Tooltip title={fm('bbSolRateReflectsProfit')}>
              <QueryIcon />
            </Tooltip>
          </div>
          <div className={styles.profitValue}>
            {formatNumber(yieldPkg?.yieldInNative ?? 0, {
              kmb: false,
              decimal: 4,
              smallNumberUseValidDigits: false,
              collapseZero: false,
            })}
          </div>
        </div>
        <div className={styles.investContainer}>
          <div className={styles.invest}>
            <div className={styles.investText}>{fm('investmentQtySol')}</div>
            <Tooltip title={fm('solQtyDetails')}>
              <QueryIcon />
            </Tooltip>
          </div>
          <div className={styles.investValue}>
            {formatNumber(extraYieldDTO?.investment?.[0]?.amount ?? 0, {
              kmb: false,
              decimal: 4,
              smallNumberUseValidDigits: false,
              collapseZero: false,
            })}
          </div>
        </div>
      </div>
    </>
  );
};
